import { useEffect, useState } from "react";

// True on very narrow phones (≈360px, e.g. Redmi 13C) so layouts can compact.
const Q = "(max-width: 380px)";

export function useIsNarrow(): boolean {
  const [narrow, setNarrow] = useState(
    () => typeof window !== "undefined" && window.matchMedia(Q).matches,
  );
  useEffect(() => {
    const m = window.matchMedia(Q);
    const h = () => setNarrow(m.matches);
    m.addEventListener("change", h);
    return () => m.removeEventListener("change", h);
  }, []);
  return narrow;
}
